<template>
    <div
        class="apprentice-simple-card"
        v-if="loaded">
        <design-2021-apprentice-data-table
            :items="deadlines"
            :fields="fields">
            <template v-slot:options>
                <div class="apprentice-group-table-actions">
                    <b-button
                        class="btn-add btn-new-group"
                        v-b-modal="'deadline-add-deadline-modal'"
                        variant="primary">
                        {{ $t('deadline.new_deadline') }}
                    </b-button>
                </div>

                <design-2021-deadlines-index-add-deadline-modal-component></design-2021-deadlines-index-add-deadline-modal-component>
            </template>

            <template v-slot:cell(action)="data">
                <div class="group-actions">
                    <b-button
                        class="btn-edit btn-edit-group remove-icon-margin"
                        v-b-tooltip="$t('deadline.edit_deadline')"
                        v-b-modal="'deadline-edit-deadline-modal' + data.item.id"
                        variant="primary-icon-only">
                    </b-button>
                    <b-button
                        class="btn-remove btn-remove-group"
                        variant="danger-icon-only"
                        :v-b-tooltip="$t('deadline.delete_deadline')"
                        @click="deleteDeadline(data.item)">
                    </b-button>
                </div>

                <design-2021-deadlines-index-edit-deadline-modal-component
                    :deadline-in="data.item"></design-2021-deadlines-index-edit-deadline-modal-component>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
import { ords } from '../../app';

export default {
    name: 'design-2021-deadlines-index-component',
    props: ['deadlineListItemsIn'],
    data() {
        return {
            fields: [
                {
                    key: 'agenda_item.full_date_time',
                    label: 'Deadline',
                    sortable: true,
                },
                {
                    key: 'date',
                    label: this.$t('deadline.delivery_date'),
                    sortable: true,
                },
                {
                    key: 'type',
                    label: 'Type',
                    sortable: true,
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
            loaded: false,
            deadlines: [],
        };
    },
    methods: {
        deleteDeadline(deadline) {
            this.alert
                .confirm(this.$t('deadline.delete_deadline_are_you_sure_you_want_to_delete_this_deadline'))
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.deadlineDelete(deadline.id)).then(
                            (response) => {
                                deadline.update({ type_id: response.data.type_id });

                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
    },
    mounted() {
        if (!this.loaded) {
            ords.use('deadline').add(this.deadlineListItemsIn);

            ords.use('deadline')
                .with('agenda_item')
                .whereHas('agenda_item')
                .where('type_id', '!=', 5)
                .get()
                .subscribe((deadline) => {
                    this.deadlines = deadline;
                });

            this.loaded = true;
        }
    },
};
</script>

<style scoped>
.group-actions {
    display: flex;
    margin-right: 21px;
}

.group-actions .btn:not(:last-child) {
    margin-right: 21px;
}
</style>
